import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommercialPortfolioService } from 'src/app/services/commercial-portfolio.service';
import { CarteraList, CommercialPortfolio } from 'src/app/interfaces';
import { ColLabel, IButtonTable } from '../table/table.interface';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { AuthService } from 'src/app/auth';
@Component({
  selector: 'app-commercial-portfolio',
  templateUrl: './commercial-portfolio.component.html'
})
export class CommercialPortfolioComponent implements OnInit {
  destroyed$: Subject<boolean> = new Subject<boolean>();

  isLoading = true;

  data: CommercialPortfolio;

  impagos: number;

  carteraList: CarteraList[];

  colsTable: ColLabel[] = [];

  public isUserSpanish = true;

  constructor(
    private commercialPortfolioService: CommercialPortfolioService,
    private utilService: UtilService,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.isUserSpanish = this.authService.getUserData().country === 'ES';
    this.commercialPortfolioService
      .getCommercialPortfolio()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        res => {
          this.data = res.data;

          this.impagos = this.data.impagos;

          this.carteraList = this.data.carteraList;
          this.carteraList.forEach(item => item.consumoAnual = item.consumoAnual * 1000);
          this.colsTable = [
            {
              label: this.isUserSpanish ? 'COMMERCIAL_PORTFOLIO.BUSINESS' : 'COMMERCIAL_PORTFOLIO.BUSINESS_DEBT',
              field: this.isUserSpanish ? ['nombreRS'] : ['nombreRS', 'deuda'],
              fieldClass: this.isUserSpanish ? [''] : ['', 'currency'],
              action: ''
            },
            {
              label: 'COMMERCIAL_PORTFOLIO.CURRENT_CONTRACT',
              field: ['fechaInicio'],
              fieldClass: ['date'],
              action: ''
            },
            {
              label: 'COMMERCIAL_PORTFOLIO.ANNUAL_CONSUMPTION',
              field: ['consumoAnual'],
              fieldClass: ['number'],
              action: ''
            },
            {
              label: 'COMMERCIAL_PORTFOLIO.N_INSTALLATIONS',
              field: ['numInstalaciones'],
              fieldClass: ['number'],
              action: ''
            },
            {
              label: '',
              field: ['idRazonSocial'],
              fieldClass: ['buttonFixed'],
              action: 'goToClicked',
              nameIcon: 'arrow',
              columnClass: 'buttonFixed'
            }
          ];
          this.isLoading = false;
        },
        error => {
          this.utilService.toastErrors(error);
        }
      );
  }

  public handleButton(event: IButtonTable): void {
    if (event.data.idRazonSocial) {
      this.router.navigate(
        ['customers/all/pymes'],
        { queryParams: this.isUserSpanish ?
          { id: event.data.idRazonSocial, tab: 'home-pymes', cif: event.data.cif } :
          { id: event.data.idRazonSocial, tab: 'home-pymes' }
        }
      );
    }
  }

  public handleNavigate(): void {
    this.router.navigate(['customers'], { queryParams: { tab: 0 } });
  }
}
